/*
 * @Descripttion: 
 * @Author: KevinYoung
 * @Date: 2020-09-27 10:04:30
 * @LastEditors: KevinYoung
 * @LastEditTime: 2020-09-27 10:36:10
 */
import React from "react";
import "./App.css"

class VideoPlayer extends React.Component {
    componentDidMount() {
        this.setStream(this.props.stream);
    }
    componentWillReceiveProps(props) {
        this.setStream(props.stream);
    }
    srcObject;
    setStream(stream) {
        if (this.srcObject != stream) {
            this.srcObject = stream;
            this.device.srcObject = stream;
        }
    }
    render() {
        return <video 
                    autoPlay 
                    muted 
                    ref={(e) => this.device = e}
                    className="full" 
                    style={{ background: "#000", width: '100vw', height: '100vh' }} 
                />;
    }
}

/**
 * 通话显示
 */
export class RtcLinkView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { link: props.link, stream: this.refreshStream(props.link) };
        props.link.on("addtrack", this._onaddtrack);
    }
    componentWillReceiveProps(props) {
        this.setChannel(props.link);
    }
    setChannel(link) {
        if (this.state.link != link) {
            if (this.state.link) this.state.link.removeListener("addtrack", this._onaddtrack);
            if(link) link.on("addtrack", this._onaddtrack);
            this.setState({ link, stream: this.refreshStream(link) });
        }
    }
    refreshStream(link) {
        if (!link || !link.stream) return null;
        var stream = link.stream;
        if (stream.getVideoTracks().length == 0 && stream.getAudioTracks().length == 0) stream = null;
        return stream;
    }
    _onaddtrack = () => {
        this.setState({ stream: this.refreshStream(this.state.link) });
    };
    componentWillUnmount() {
        if (this.state.link) this.state.link.removeListener("addtrack", this._onaddtrack);
    }
    render() {
        //return this.state && this.state.stream && false
        return this.state && this.state.stream
            ? <VideoPlayer stream={this.state.stream} />
            : <div className="full loading">
                <img src={require("./img/monitor.png")} alt=""/>
                <span>视频加载中...</span>
            </div>
    }


}